import { render, staticRenderFns } from "./SSS.vue?vue&type=template&id=0198907a&scoped=true"
import script from "./SSS.vue?vue&type=script&lang=js"
export * from "./SSS.vue?vue&type=script&lang=js"
import style0 from "./SSS.vue?vue&type=style&index=0&id=0198907a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198907a",
  null
  
)

export default component.exports